import React from "react";
import Api from "app/js/api";
import { useUserStore } from "app/js/stores";
import { useHistory, useLocation } from "react-router-dom";

import styles from "./IDPSuccess.scss";

export default function IDPSuccess() {
  const [_user, userActions] = useUserStore();
  const history = useHistory();
  const location = useLocation<{ from: Location } | undefined>();
  const params = new URLSearchParams(location.search) as { next?: string };
  const next = params?.next ?? "/";

  React.useEffect(() => {
    async function fetchToken() {
      try {
        const response = await Api.user().getTokenFromSession();
        userActions.setToken(response.data.token);
        history.replace(next);
      } catch (error) {
        history.replace("/");
      }
    }

    fetchToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      Please, wait a bit. You will be redirected after authentication process
      finish.
    </div>
  );
}
